export type DataVizGradient = "gradient1" | "gradient2" | "gradient3" | "gradient4" | "gradient5";

export const DATA_VIZ_GRADIENTS: readonly DataVizGradient[] = [
    "gradient1",
    "gradient2",
    "gradient3",
    "gradient4",
    "gradient5"
];

export const isDataVizGradient = (value: unknown): value is DataVizGradient =>
    typeof value === "string" && (DATA_VIZ_GRADIENTS as readonly string[]).includes(value);

export const PIE_REVERSED_GRADIENTS = new Set<DataVizGradient>(["gradient3", "gradient5"]);

export const CUMULATIVE_BAR_ROTATIONS: Record<DataVizGradient, number> = {
    gradient1: 177,
    gradient2: 19,
    gradient3: 167,
    gradient4: 0,
    gradient5: -13
};

export const BRAND_GRADIENT_FILL =
    "linear-gradient(109deg, var(--dataviz-gradient2-start-color) 12.44%, var(--dataviz-gradient2-stop-color) 86.89%)";
